module.exports = __webpack_public_path__ + "static/img/logo.8cf7a116.png";